import React from 'react'

const SFDCSSOForm = ({ sfdcData }) => {
  return (
    <form method="POST" action={sfdcData.entityEndpoint}>
      <input type="hidden" name="SAMLResponse" value={sfdcData.context} />
      <input type="hidden" name="RelayState" value={sfdcData.relayState} />
    </form>
  )
}

export default SFDCSSOForm
